import { EffectsCommandMap } from 'dva';
import { AVATAR_URL_PREFIX } from '@/constants';
import { ConnectState } from '@/models/connect';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import fMessage from '@/components/fMessage';
import dayjs from 'dayjs';
import {
  ICollectionCreateVersionDraftType,
  IResourceCreateVersionDraftType,
} from '@/type/resourceTypes';
import type {
  ChangeAction,
  OnChange_step2_resources_Action,
  Step2_Fetch_CollectionItems_Action,
  OnChange_step2_systemProperties_Action,
  OnChange_step2_customProperties_Action,
  OnChange_step2_customConfigurations_Action,
  OnSync_Step2_properties_Action,
  Step2_SaveDraft_Action,
  OnClick_step2_submitBtn_Action,
} from './types';
import type { CollectionCreatorPageModelState } from './types';

export const step2Effects = {
  *onChange_step2_resources(
    { payload }: OnChange_step2_resources_Action,
    { put }: EffectsCommandMap,
  ) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step2_resources: payload.value,
      },
    });
  },
  *step2_Fetch_CollectionItems(
    {}: Step2_Fetch_CollectionItems_Action,
    { select, call, put }: EffectsCommandMap,
  ) {
    const { collectionCreatorPage }: ConnectState = yield select(
      ({ collectionCreatorPage }: ConnectState) => ({
        collectionCreatorPage,
      }),
    );

    let data_collectionItems: {
      createDate: string;
      itemId: string;
      itemTitle: string;
      sortId: number;
      number: string;
      mountResourceInfo: {
        resourceId: string;
      };
    }[] = [];

    const parmas = {
      resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
      skip:
        (collectionCreatorPage.step2_resources_pageCurrent - 1) *
        collectionCreatorPage.step2_resources_pageSize,
      limit: collectionCreatorPage.step2_resources_pageSize,
      keywords: collectionCreatorPage.step2_resourceKeywords,
      sortType:
        collectionCreatorPage.step2_collectionItemsSetting.collection_sort_list ===
        'collection_sort_descending'
          ? -1
          : 1,
      isLoadLatestVersionInfo: 1,
    };

    const {
      ret,
      errCode,
      data,
    }: {
      ret: number;
      errCode: number;
      data: {
        skip: number;
        limit: number;
        totalItem: number;
        dataList: {
          createDate: string;
          itemId: string;
          itemTitle: string;
          sortId: number;
          number: string;
          mountResourceInfo: {
            resourceId: string;
          };
        }[];
      };
    } = yield call(FServiceAPI.Resource.getCollectionItems_Draft, parmas);

    data_collectionItems = data.dataList;
    if (
      data.dataList.length === 0 &&
      collectionCreatorPage.step2_resources_pageCurrent > 1 &&
      data.totalItem > 0
    ) {
      const step2_resources_pageCurrent: number =
        Math.floor((data.totalItem - 1) / collectionCreatorPage.step2_resources_pageSize) + 1;

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          step2_resources_pageCurrent: step2_resources_pageCurrent,
        },
      });

      const parmas2 = {
        resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
        skip: (step2_resources_pageCurrent - 1) * collectionCreatorPage.step2_resources_pageSize,
        limit: collectionCreatorPage.step2_resources_pageSize,
        keywords: collectionCreatorPage.step2_resourceKeywords,
        sortType:
          collectionCreatorPage.step2_collectionItemsSetting.collection_sort_list ===
          'collection_sort_descending'
            ? -1
            : 1,
      };

      const {
        ret: ret2,
        errCode: errCode2,
        data: data1,
      }: {
        ret: number;
        errCode: number;
        data: {
          skip: number;
          limit: number;
          totalItem: number;
          dataList: {
            createDate: string;
            itemId: string;
            itemTitle: string;
            sortId: number;
            number: string;
            mountResourceInfo: {
              resourceId: string;
            };
          }[];
        };
      } = yield call(FServiceAPI.Resource.getCollectionItems_Draft, parmas2);

      data_collectionItems = data1.dataList;
    }

    let data_resourceList: any[] = [];
    let auths: {
      itemId: string;
      isAuth: boolean;
    }[] = [];
    if (data_collectionItems.length > 0) {
      const { data: data_resourceList1 } = yield call(FServiceAPI.Resource.batchInfo, {
        resourceIds: data_collectionItems
          .map((d) => {
            return d.mountResourceInfo.resourceId;
          })
          .join(','),
      });
      data_resourceList = data_resourceList1;

      const parmas1 = {
        resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
        itemIds: data_collectionItems
          .map((d) => {
            return d.itemId;
          })
          .join(','),
      };
      const {
        data: data1,
      }: {
        data: {
          itemId: string;
          isAuth: boolean;
        }[];
      } = yield call(FServiceAPI.Resource.getCollectionItemsAuth_Draft, parmas1);
      auths = data1;
    }

    const list: CollectionCreatorPageModelState['step2_resources'] = data_collectionItems.map<
      CollectionCreatorPageModelState['step2_resources'][number]
    >((i) => {
      const resAuth = auths.find((dd) => {
        return dd.itemId === i.itemId;
      });
      const resource = data_resourceList.find((r) => {
        return r.resourceId === i.mountResourceInfo.resourceId;
      });
      return {
        itemID: i.itemId,
        itemTitle: i.itemTitle,
        itemSerial: i.sortId,
        itemNumber: i.number,
        resourceInfo: {
          id: resource.resourceId,
          cover: resource.coverImages.length > 0 ? resource.coverImages[0] : '',
          name: resource.resourceName,
          title: resource.resourceTitle,
          version: resource.latestVersion,
          policy: resource.policies
            .filter((l: any) => {
              return l.status === 1;
            })
            .map((l: any) => l.policyName),
          type: resource.resourceType,
          status: resource.status,
          authProblem: !!resAuth && !resAuth.isAuth,
          updateDate: dayjs(resource.updateDate).format(FUtil.Predefined.momentDateFormat),
          username: resource.username,
          useAvatar: `${AVATAR_URL_PREFIX}${resource.userId}`,
          isChoice: resource.operationType === 5,
          intro: resource.intro,
        },
      };
    });

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step2_resources: list,
        step2_resources_totalCount: data.totalItem,
        step2_resources_state:
          data.totalItem > 0
            ? 'loaded'
            : collectionCreatorPage.step2_resourceKeywords === ''
            ? 'noData'
            : 'noSearchResult',
      },
    });
  },
  *onChange_step2_systemProperties(
    { payload }: OnChange_step2_systemProperties_Action,
    { put }: EffectsCommandMap,
  ) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step2_systemProperties: payload.value,
      },
    });
  },
  *onChange_step2_customProperties(
    { payload }: OnChange_step2_customProperties_Action,
    { put }: EffectsCommandMap,
  ) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step2_customProperties: payload.value,
      },
    });
  },
  *onChange_step2_customConfigurations(
    { payload }: OnChange_step2_customConfigurations_Action,
    { put }: EffectsCommandMap,
  ) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step2_customConfigurations: payload.value,
      },
    });
  },
  *onSync_Step2_properties(
    {}: OnSync_Step2_properties_Action,
    { select, call, put }: EffectsCommandMap,
  ) {
    const { collectionCreatorPage }: ConnectState = yield select(
      ({ collectionCreatorPage }: ConnectState) => ({
        collectionCreatorPage,
      }),
    );

    const authExcludedItems: {
      resourceId: string;
      excludedType: 'contractId' | 'policyId';
      excludedValue: string;
    }[] = collectionCreatorPage.step2_authExcludedItems.flatMap((r0) => {
      return r0.contracts.map((r1) => {
        return {
          resourceId: r0.resourceID,
          excludedType: 'contractId' as const,
          excludedValue: r1.contractID,
        };
      });
    });

    const params = {
      resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
      authExcludedItems: authExcludedItems,
      customPropertyDescriptors: [
        ...collectionCreatorPage.step2_customProperties.map((i) => {
          return {
            type: 'readonlyText',
            key: i.key,
            name: i.name,
            remark: i.description,
            defaultValue: i.value,
          };
        }),
        ...collectionCreatorPage.step2_customConfigurations.map((i) => {
          const isInput: boolean = i.type === 'input';
          const options: string[] = i.select;
          return {
            type: isInput ? 'editableText' : 'select',
            key: i.key,
            name: i.name,
            remark: i.description,
            defaultValue: isInput ? i.input : options[0],
            candidateItems: isInput ? undefined : options,
          };
        }),
      ],
    };

    const {
      ret,
      errCode,
      msg,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: any;
    } = yield call(FServiceAPI.Resource.updateCollection, params);

    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
    }
  },
  *step2_SaveDraft({}: Step2_SaveDraft_Action, { select, call, put }: EffectsCommandMap) {
    const { collectionCreatorPage }: ConnectState = yield select(
      ({ collectionCreatorPage }: ConnectState) => ({
        collectionCreatorPage,
      }),
    );

    // RSS 导入进行中停用草稿读写
    if (collectionCreatorPage.step2_rssImportProcessing) {
      return;
    }

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step2_draftSaving: true,
      },
    });

    const params1 = {
      resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
    };
    const {
      data: data_draft1,
    }: {
      data: null | {
        resourceId: string;
        updateDate: string;
        draftData: IResourceCreateVersionDraftType;
      };
    } = yield call(FServiceAPI.Resource.lookDraft, params1);

    const draftData: ICollectionCreateVersionDraftType = {
      ...(data_draft1?.draftData || {}),
      collectionItemsSetting: collectionCreatorPage.step2_collectionItemsSetting,
      additionalProperties: collectionCreatorPage.step2_systemProperties
        .filter((sp) => sp.type === 'additional')
        .map((sp) => {
          return {
            key: sp.key,
            value: sp.value,
          };
        }),
      customProperties: collectionCreatorPage.step2_customProperties,
      customConfigurations: collectionCreatorPage.step2_customConfigurations,
      directDependencies: collectionCreatorPage.step2_directDependencies,
      baseUpcastResources: collectionCreatorPage.step2_baseUpcastResources,
      descriptionEditorInput: '',
      collectionItemsChanged: collectionCreatorPage.step2_collectionItemsChanged,
      otherChanged: collectionCreatorPage.step2_otherChanged,
    };

    const params = {
      resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
      draftData: draftData,
    };
    const {
      ret,
      errCode,
      data: data_draft,
    }: {
      ret: number;
      errCode: number;
      data: {
        resourceId: string;
        updateDate: string;
        draftData: IResourceCreateVersionDraftType;
      };
    } = yield call(FServiceAPI.Resource.saveVersionsDraft, params);
    if (ret !== 0 || errCode !== 0) {
      fMessage('草稿保存失败', 'error');
      return;
    }
    yield call(FUtil.Tool.promiseSleep, 500);

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step2_draftSaving: false,
        step2_draftSaveTime: dayjs(data_draft.updateDate).format('YYYY-MM-DD HH:mm:ss'),
      },
    });
  },
  *onClick_step2_submitBtn(
    {}: OnClick_step2_submitBtn_Action,
    { select, call, put }: EffectsCommandMap,
  ) {
    const { collectionCreatorPage }: ConnectState = yield select(
      ({ collectionCreatorPage }: ConnectState) => ({
        collectionCreatorPage,
      }),
    );

    const authExcludedItems: {
      resourceId: string;
      excludedType: 'contractId' | 'policyId';
      excludedValue: string;
    }[] = collectionCreatorPage.step2_authExcludedItems.flatMap((r0) => {
      return r0.contracts.map((r1) => {
        return {
          resourceId: r0.resourceID,
          excludedType: 'contractId' as const,
          excludedValue: r1.contractID,
        };
      });
    });

    const params = {
      resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
      inputAttrs: collectionCreatorPage.step2_systemProperties
        .filter((sp) => sp.type === 'additional')
        .map((sp) => {
          return {
            key: sp.key,
            value: sp.value,
          };
        }),
      customPropertyDescriptors: [
        ...collectionCreatorPage.step2_customProperties.map((i) => {
          return {
            type: 'readonlyText',
            key: i.key,
            name: i.name,
            remark: i.description,
            defaultValue: i.value,
          };
        }),
        ...collectionCreatorPage.step2_customConfigurations.map((i) => {
          const isInput: boolean = i.type === 'input';
          const options: string[] = i.select;
          return {
            type: isInput ? 'editableText' : 'select',
            key: i.key,
            name: i.name,
            remark: i.description,
            defaultValue: isInput ? i.input : options[0],
            candidateItems: isInput ? undefined : options,
          };
        }),
      ],
      description: '',
      catalogueProperty: collectionCreatorPage.step2_collectionItemsSetting,
      dependencies: collectionCreatorPage.step2_directDependencies.map((r) => {
        return {
          resourceId: r.id,
          versionRange: r.versionRange || '',
        };
      }),
      authExcludedItems: authExcludedItems,
      isMergeCatalogueDraft: collectionCreatorPage.step2_collectionItemsChanged ? 1 : 0,
    };

    const {
      ret,
      errCode,
      msg,
    } = yield call(FServiceAPI.Resource.updateCollection, params);

    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
    }
  },
};
